/* ArmadaMeds accessibility fixes (doc 107, step 30a, 2 Oct 2026).
   Small, defensive DOM corrections for markup the theme's own scripts control. */
(function () {
  'use strict';

  var FOCUSABLE = 'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"]), [contenteditable="true"]';
  var HIDDEN_CELL = '.product-item[aria-hidden], .flickity-slider > [aria-hidden]';

  /* A3 — carousel cells hidden with aria-hidden="true" must not hold keyboard focus.
     Off-screen cells get tabindex="-1" on their links/buttons; the original value is restored
     when the slider shows the cell again. Mouse and touch clicks are unaffected. */
  function syncHiddenCell(cell) {
    var hidden = cell.getAttribute('aria-hidden') === 'true';
    var nodes = cell.querySelectorAll(FOCUSABLE + ', [data-a11y-tabindex]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (hidden) {
        if (!el.hasAttribute('data-a11y-tabindex')) {
          el.setAttribute('data-a11y-tabindex', el.hasAttribute('tabindex') ? el.getAttribute('tabindex') : '');
        }
        el.setAttribute('tabindex', '-1');
      } else if (el.hasAttribute('data-a11y-tabindex')) {
        var original = el.getAttribute('data-a11y-tabindex');
        if (original === '') { el.removeAttribute('tabindex'); } else { el.setAttribute('tabindex', original); }
        el.removeAttribute('data-a11y-tabindex');
      }
    }
  }

  /* A5 — aria-expanded is not allowed on a plain <div>. The cart icon's open/close state moves to
     data-expanded (am-a11y.css mirrors the theme's icon swap); the real state stays on the cart link. */
  function fixCartIcon(el) {
    if (el.hasAttribute('aria-expanded')) {
      el.setAttribute('data-expanded', el.getAttribute('aria-expanded'));
      el.removeAttribute('aria-expanded');
    }
  }

  /* A5 — collection description: the theme keeps its expand state in aria-expanded on the wrapper <div>.
     Give the wrapper role="group" (which permits aria-expanded) and mirror the state onto the real
     toggle <button> so screen readers announce "expanded / collapsed". */
  function fixExpandable(el) {
    if (!el.hasAttribute('role')) {
      el.setAttribute('role', 'group');
      el.setAttribute('aria-label', 'Collection description');
    }
    var toggle = el.querySelector('.expandable-content__toggle');
    if (toggle) {
      if (toggle.tagName === 'BUTTON' && !toggle.hasAttribute('type')) { toggle.setAttribute('type', 'button'); }
      var state = el.getAttribute('aria-expanded');
      if (state === 'true' || state === 'false') { toggle.setAttribute('aria-expanded', state); }
    }
  }

  /* A8 — the logo link already carries a visually-hidden shop name, so the image is decorative. */
  function fixLogo() {
    var imgs = document.querySelectorAll('.header__logo-link .header__logo-image');
    for (var i = 0; i < imgs.length; i++) {
      var link = imgs[i].closest('.header__logo-link');
      if (link && link.querySelector('.visually-hidden')) { imgs[i].setAttribute('alt', ''); }
    }
  }

  /* A7 — content above the page body (announcement bar, trust strip) gets a labelled region landmark. */
  function fixLandmarks() {
    var ann = document.querySelector('section[data-section-type="announcement-bar"]');
    if (ann && !ann.hasAttribute('aria-label')) {
      ann.setAttribute('role', 'region');
      ann.setAttribute('aria-label', 'Announcement');
    }
    var strips = document.querySelectorAll('section[data-section-type="text-with-icons"]');
    for (var i = 0; i < strips.length; i++) {
      var s = strips[i];
      if (s.closest('main, header, footer, aside, nav, [role="region"]')) { continue; }
      s.setAttribute('role', 'region');
      s.setAttribute('aria-label', 'Why shop with us');
    }
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var cells = scope.querySelectorAll(HIDDEN_CELL);
    for (var i = 0; i < cells.length; i++) { syncHiddenCell(cells[i]); }
    var icons = scope.querySelectorAll('.header__cart-icon[aria-expanded]');
    for (var j = 0; j < icons.length; j++) { fixCartIcon(icons[j]); }
    var exps = scope.querySelectorAll('.expandable-content[aria-expanded]');
    for (var k = 0; k < exps.length; k++) { fixExpandable(exps[k]); }
  }

  function init() {
    fixLogo();
    fixLandmarks();
    scan(document);

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        var t = m.target;
        if (m.type === 'attributes' && t.nodeType === 1) {
          if (m.attributeName === 'aria-hidden' && t.matches && t.matches(HIDDEN_CELL)) { syncHiddenCell(t); }
          if (m.attributeName === 'aria-expanded') {
            if (t.classList.contains('header__cart-icon')) { fixCartIcon(t); }
            if (t.classList.contains('expandable-content')) { fixExpandable(t); }
          }
        } else if (m.type === 'childList') {
          for (var n = 0; n < m.addedNodes.length; n++) {
            var node = m.addedNodes[n];
            if (node.nodeType === 1) {
              if (node.matches && node.matches(HIDDEN_CELL)) { syncHiddenCell(node); }
              scan(node);
            }
          }
        }
      }
    });
    observer.observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['aria-hidden', 'aria-expanded']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
